import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

import logger from "./utils/logger";
import MultiAPILink from "./multi-link";

const errorLink: any = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, path }) =>
      logger.error(`[GraphQL error]: Message: ${message}, Path: ${path}`)
    );

  if (networkError) logger.error(`[Network error]: ${networkError}`);
});

const multiApiLink: any = new MultiAPILink();

export const apolloClient = new ApolloClient({
  link: from([errorLink, multiApiLink]),
  cache: new InMemoryCache() as any,
});
